module.exports = __webpack_public_path__ + "static/1357522236.48d26e06.jpg";